'use strict';

const productTile = require('../product-tile');

const promotions = {
    init: function () {
        productTile.init();
    }
};

module.exports = promotions;
